<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <section class="inner_wrap order-response">
            <div class="container"> 
                <div class="row ">
                    <div class="col-md-12">
                    	<div id="error-resp" v-html="errormessage" class="text-center"></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
export default{
    data() {
        return {
            hostname:this.$hostname,
            errors:[],
            errormessage:''
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods: {
        check_response(){
        	
        }
    },
    mounted(){
        var _self = this;
    	var response = this.$route.query;
    	if(response.status=="failed"){
    		this.errormessage = `<p>Transaction ID: ${response.id}</p>
    							<p>${response.message}</p>`;
    	}
        else{
            this.errormessage = `<p>Transaction ID: ${response.id}</p>
                                <p>Order created Successfully</p>`;
            
        }
        this.$axios_global.post(_self.$hostname+'/api/update-payment-status',{
                id:response.id,
                status:response.status
            })
            .then((response) => {
                console.log(response,"1111111111111")
            })
            .catch((error) => {
                console.log(error,"2222222222")
                return false;  
            }) 
            return false; 
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Checkout/OrderResponse.vue